/**
 * type for the offline status, to be used for tracking and displaying information about the offline status
 */
export interface OfflineStatus {
  unsyncedCount: number;
  connected: boolean;
  connectionText: string;
  incomingCacheCount: number;
  cachingDocEnableDate?: number;
  maxCacheCount: number;
  currentCacheCount: number;
  cacheLoading: boolean;
  pendingDocumentCount: number;
  errorCacheCount: number;
  initialCachingComplete: boolean;
  initialDataCachingCompleted?: boolean;
  initialAssetsCachingCompleted?: boolean;
  initialMapTilesCachingCompleted?: boolean;
  cachingApp: boolean;
  currentStaticResourceCount: number;
  totalStaticResourceCount: number;
  tileServerCacheCount: number;
  tileServerMaxCacheCount: number;
  errorCacheAttachedFile: any;
  errorOfflineChangesSyncDocs: any,
  maxCacheAttachedFileCount: number,
  currentCacheAttachedFileCount: number,
  enabled: boolean,
  operateOnline: boolean;
  pendingUploadCount: number;
}
